import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    debug: false,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
      //  performance
      // If you're using react router, use the integration for your react router version instead.
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.browserTracingIntegration(),
      //  performance
      //  session-replay
      Sentry.replayIntegration(),
      //  session-replay
      //  user-feedback
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
      //  user-feedback
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    ],
    //  logs
    // Enable logs to be sent to Sentry
    enableLogs: true,
    //  logs
    //  performance
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.3,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      "https://server-staging-a6f9.up.railway.app/",
      "https://server-production-4c7e.up.railway.app/",
    ],
    //  performance
    //  session-replay
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    // replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    //  session-replay
  });
}
